import PropTypes from 'prop-types'
import { deleteDashboardItems } from 'features/dashboard/operation/delete/deleteSlice'
import { batch, shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  refreshDashboardTable,
  refreshDashboardTree,
} from 'features/dashboard/dashboardCommonSlice'
import Icon from 'components/Icon'
import Button from 'components/form/Button'
import { success, fail } from 'features/toast/Toast'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'
import { useDashboardTypeName } from 'features/dashboard/utils/hooks/useDashboardTypeName'
import { useConfirm } from 'features/dialog/Confirm'
import { DashboardTypes } from 'features/Codes'

const KEYWORD_DELETE_LIMIT_EXCEEDED = 105017

const DashboardTableDeleteMessages = {
  [DashboardTypes.CAMPAIGN]: (
    <>
      캠페인을 삭제하시겠습니까?
      <br />
      캠페인 하위의 광고그룹과 키워드, 선택된 소재 정보가 함께 삭제됩니다.
    </>
  ),
  [DashboardTypes.AD_GROUP]: (
    <>
      광고그룹을 삭제하시겠습니까?
      <br />
      광고그룹에 속한 키워드와 소재 정보가 함께 삭제됩니다.
    </>
  ),
  [DashboardTypes.KEYWORD]: '키워드를 삭제하시겠습니까?',
  [DashboardTypes.CREATIVE]: '해당 그룹에서 소재를 삭제하시겠습니까?',
}
const DeleteButton = () => {
  const dispatch = useDispatch()
  const { selectedIds, page } = useDashboardTableSelector()
  const { setPage, setSelectedIds } = useDashboardTableActions()
  const { type, name } = useDashboardTypeName()
  const { isSubmitting } = useSelector(
    state => state.dashboard.operation.delete,
    shallowEqual
  )
  const [DeleteConfirm, showDeleteConfirm] = useConfirm()
  const handleDelete = async () => {
    const { error, payload } = await dispatch(
      deleteDashboardItems({
        type,
        ids: selectedIds,
      })
    )
    if (error) {
      fail(
        payload?.errorCode === KEYWORD_DELETE_LIMIT_EXCEEDED
          ? payload.errorMessage
          : `${name} 변경사항을 적용할 수 없습니다.`
      )
    } else {
      success(`${name} 변경사항이 적용되었습니다.`)
      batch(() => {
        dispatch(setSelectedIds([]))
        if (page === 0) {
          dispatch(refreshDashboardTable())
        } else {
          dispatch(setPage(0))
        }
        dispatch(refreshDashboardTree())
      })
    }
  }
  return (
    <>
      <Button
        icon
        line
        disabled={selectedIds.length < 1 || isSubmitting}
        onClick={showDeleteConfirm}>
        <Icon name="del">삭제</Icon>
      </Button>
      <DeleteConfirm
        title={`${name} 삭제`}
        confirmDisabled={setSelectedIds.length === 0}
        onClose={({ isConfirmed }) => isConfirmed && handleDelete()}>
        {DashboardTableDeleteMessages[type]}
      </DeleteConfirm>
    </>
  )
}
DeleteButton.propTypes = {
  type: PropTypes.string,
}
export default DeleteButton
